import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { isScanningMember } from '../utils/permissions';

/**
 * Keeps client users out of the staff panel (they only see /client), and
 * scanning members out of the web panel altogether: they use the handheld
 * (HHT) app only.
 */
function StaffRoute({ children }) {
  const { user, loading, logout } = useAuth();

  if (loading) {
    return null;
  }

  if (user?.role_name === 'client') {
    return <Navigate to="/client" replace />;
  }

  if (isScanningMember(user)) {
    return (
      <div style={{ maxWidth: 460, margin: '15vh auto', padding: 24, textAlign: 'center' }}>
        <h1 style={{ fontSize: '1.4rem' }}>Use the handheld app</h1>
        <p style={{ color: '#475569' }}>
          Scanning members sign in on the handheld (HHT) app only. Ask an Admin if you need access
          to the web panel.
        </p>
        <button type="button" onClick={() => logout?.()}>
          Sign out
        </button>
      </div>
    );
  }

  return children;
}

export default StaffRoute;
